import React from 'react'
import { useLocation } from 'react-router-dom'
import { forstokCookies } from '../_includes/forstok'
import Auth from '../pages/login/auth/auth'
import LinkComponent from '../components/link/link.component'
import HeaderInclude from '../_includes/header/header-include'

// import HeaderInclude from '../_includes/header/header-include'
import { AdminContainer, NavContainer, LinkContainer, LayoutNavContainer, LayoutContentContainer } from './admin.styles'

import { GridContainer, GridHeader, GridSidenav, GridSidenavList, GridSidenavListItem, GridMain, GridFooter } from './layout.styles'
import { SideContainer, LogoContainer } from '../pages/login/login.styles'


import { useQuery } from '@apollo/client'
import { GET_CURRENT_USER } from '../config/graphql'

const GridLayout = ({ children, ...props }) => {
  let location = useLocation();

  const { loading, data } = useQuery(GET_CURRENT_USER);
  const {history} = props
  const currentUser = data?.currentUser?.name || '';
  console.log(data);
  console.log(data?.permissions?.find((permission) => permission.id == '8'));

  // const handleLogout = () => {
  //   if(process.env.NODE_ENV === 'development') {
  //     forstokCookies.remove('admin_token',{ path: '/' })
  //   }else {
  //     forstokCookies.remove('admin_token',{ path: '/' })
  //   }
  //   Auth.logout(() => { history.push('/')  })
  // }

  return (
    <GridContainer>
      <GridHeader>
        <div>{currentUser}</div>
        <HeaderInclude />
      </GridHeader>
      <GridSidenav>
        
          {(() => {
              if (data?.permissions?.find((permission) => permission.id == '7')) {
                return (
                  <GridSidenavList>
                    <GridSidenavListItem>
                      <SideContainer style={{padding: '80px'}}>
                        <LogoContainer></LogoContainer>
                      </SideContainer>
                    </GridSidenavListItem>
                    <GridSidenavListItem>
                      <LinkContainer to='/dashboard/transactions' isactive={location.pathname === '/dashboard/transactions' ? 1 : 0}>Transaksi</LinkContainer>
                    </GridSidenavListItem>
                    <GridSidenavListItem>
                      <LinkContainer to='/dashboard/cash_accounts' isactive={location.pathname === '/dashboard/cash_accounts' ? 1 : 0}>Saldo</LinkContainer>
                    </GridSidenavListItem>
                    <GridSidenavListItem>
                      <LinkContainer to='/dashboard/activities' isactive={location.pathname === '/dashboard/activities' ? 1 : 0}>Aktivitas</LinkContainer>
                    </GridSidenavListItem>
                    <GridSidenavListItem>
                      <LinkContainer to='/dashboard/orders' isactive={location.pathname === '/dashboard/orders' ? 1 : 0}>Pembelian</LinkContainer>
                    </GridSidenavListItem>
                  </GridSidenavList>
                )
              } else if (data?.permissions?.find((permission) => permission.id == '8')) {
                return (
                  <GridSidenavList>
                    <GridSidenavListItem>
                      <SideContainer style={{padding: '80px'}}>
                        <LogoContainer></LogoContainer>
                      </SideContainer>
                    </GridSidenavListItem>
                    <GridSidenavListItem>
                      <LinkContainer to='/dashboard/rooms' isactive={location.pathname === '/dashboard/rooms' ? 1 : 0}>Kamar</LinkContainer>
                    </GridSidenavListItem>
                  </GridSidenavList>
                )
              } else {
                return (
                  <GridSidenavList>
                  </GridSidenavList>
                )
              }
            })()
          }
          
      </GridSidenav>
      <GridMain>
        {children}
      </GridMain>
        {/* <GridFooter>
          <div class="footer__copyright">&copy; 2023</div>
          <div class="footer__signature">Powered by Genio</div>
        </GridFooter> */}
    </GridContainer>
  )
}

export default GridLayout